import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carolina M.',
    age: '34 años',
    text: 'En una semana ya no me sentía hinchada todas las noches. Algo que llevaba años así.',
    initial: 'C'
  }, {
    name: 'Valentina R.',
    age: '41 años',
    text: 'Dejé de picar dulce sin esfuerzo. Nunca pensé que era tan simple como el orden de lo que comía.',
    initial: 'V'
  }, {
    name: 'Lucía G.',
    age: '38 años',
    text: 'Por primera vez siento que como rico y me siento liviana. No tenía que elegir entre una cosa y la otra.',
    initial: 'L'
  }];
  return <section className="py-20 bg-stone-50" data-id="element-278">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="max-w-6xl mx-auto" data-id="element-280">
          <div className="text-center mb-16" data-id="element-281">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-282">
              Mujeres reales. Resultados reales.
            </h2>
            <p className="text-lg text-gray-600" data-id="element-283">
              No modelos. No influencers. Mujeres como vos que decidieron
              probar.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-284">
            {testimonials.map((t, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 relative" data-id="element-285">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-emerald-100 fill-emerald-100" data-id="element-286" />

                <div className="flex items-center gap-1 mb-4" data-id="element-287">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-288" />)}
                </div>

                <p className="text-gray-700 italic mb-6 text-lg leading-relaxed" data-id="element-289">
                  "{t.text}"
                </p>

                <div className="flex items-center gap-4 border-t border-stone-100 pt-4" data-id="element-290">
                  <div className="w-10 h-10 rounded-full bg-emerald-200 flex items-center justify-center text-emerald-800 font-bold" data-id="element-291">
                    {t.initial}
                  </div>
                  <div data-id="element-292">
                    <p className="font-bold text-gray-900" data-id="element-293">{t.name}</p>
                    <p className="text-sm text-gray-500" data-id="element-294">{t.age}</p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-295">
            <p className="text-2xl md:text-3xl font-bold text-emerald-900" data-id="element-296">
              No es fuerza de voluntad. Es método.
            </p>
          </div>
        </div>
      </div>
    </section>;
}